import { Component } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { TenantUserAccessState } from 'src/app/tenant-selector/state/tenant-user-access.state';
import { AppInsightsService } from '../../services/app-insights.service';

@Component({
  selector: 'app-logout-button',
  templateUrl: './logout-button.component.html',
  styleUrls: ['./logout-button.component.scss'],
  standalone: false,
})
export class LogoutButtonComponent {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private appInsightsService: AppInsightsService
  ) {}

  logout() {
    TenantUserAccessState.clearSelectedTenant();
    this.appInsightsService.clearAuthenticatedUserContext();
    this.oidcSecurityService.logoff();
  }
}
